import {cva} from 'class-variance-authority';

export const alertVariants = cva(
  'relative grid w-full grid-cols-[0_1fr] items-start gap-y-0.5 rounded-sharp border px-4 py-3 text-sm shadow-subtle has-[>svg]:grid-cols-[1.5rem_1fr] has-[>svg]:gap-x-3 [&>svg]:box-content [&>svg]:size-4 [&>svg]:translate-y-0.5 [&>svg]:rounded-full [&>svg]:p-1 [&>svg]:text-white',
  {
    variants: {
      variant: {
        default:
          'border-neutral-100 bg-neutral-50 text-neutral-800 [&>svg]:bg-neutral-600 *:data-[slot=alert-description]:text-neutral-700 *:data-[slot=alert-action]:text-neutral-800',
        general:
          'border-neutral-100 bg-neutral-50 text-neutral-800 [&>svg]:bg-neutral-600 *:data-[slot=alert-description]:text-neutral-700 *:data-[slot=alert-action]:text-neutral-800',
        success:
          'border-accent-200 bg-accent-100 text-primary-dark [&>svg]:bg-accent-700 *:data-[slot=alert-description]:text-primary-dark/80 *:data-[slot=alert-action]:text-primary-dark',
        warning:
          'border-warning-300 bg-warning-200 text-orange-800 [&>svg]:bg-orange-700 *:data-[slot=alert-description]:text-orange-800/80 *:data-[slot=alert-action]:text-orange-800',
        error:
          'border-danger-200 bg-danger-100 text-danger-800 [&>svg]:bg-danger-800 *:data-[slot=alert-description]:text-danger-800/80 *:data-[slot=alert-action]:text-danger-800',
        destructive:
          'border-danger-200 bg-danger-100 text-danger-800 [&>svg]:bg-danger-800 *:data-[slot=alert-description]:text-danger-800/80 *:data-[slot=alert-action]:text-danger-800',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);
